import { useEffect, useState } from "react";
import PageHero from "../components/PageHero";
import CtaSection from "../components/CtaSection";
import { Reveal } from "../components/Reveal";
import { SERVICES, IMAGES } from "../data/site";
import { useSiteImages } from "../lib/useSiteImages";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Service() {
  const [services, setServices] = useState(SERVICES);
  const siteImages = useSiteImages();

  useEffect(() => {
    fetch(`${API}/api/services`)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error("fetch failed"))))
      .then((data) => {
        if (Array.isArray(data) && data.length) {
          setServices(
            data.map((s, i) => ({
              slug: s.slug,
              titleJa: s.title_ja,
              titleEn: s.title_en,
              detail: s.detail,
              scope: s.scope || [],
              image: s.image,
              num: String(i + 1).padStart(2, "0"),
            }))
          );
        }
      })
      .catch(() => {});
  }, []);

  return (
    <div data-testid="service-page">
      <PageHero
        eyebrow="OUR BUSINESS — 01/05"
        titleEn="SERVICE"
        titleJa="事業内容"
        desc="土木から環境整備、再生可能エネルギー、不動産まで。土地のライフサイクルすべてに対応する5つの事業領域。"
        image={siteImages.service || IMAGES.excavator}
      />
      {services.map((s, i) => (
        <section key={s.slug} id={s.slug} data-testid={`service-section-${s.slug}`} className="scroll-mt-24 border-t border-line py-20 md:py-28">
          <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
            <div className="lg:col-span-4">
              <Reveal>
                <span className="font-display text-7xl font-extrabold leading-none text-accent">{s.num}</span>
              </Reveal>
              <Reveal delay={0.05}>
                <h2 className="mt-4 font-mincho text-3xl font-bold text-white sm:text-4xl">{s.titleJa}</h2>
              </Reveal>
              <Reveal delay={0.1}>
                <p className="mt-2 font-mono text-xs tracking-[0.3em] text-gray-500">{s.titleEn}</p>
              </Reveal>
            </div>
            <div className="lg:col-span-8">
              <Reveal>
                <div className="clip-corner overflow-hidden border border-line">
                  <img src={s.image} alt={s.titleJa} loading="lazy" className="aspect-[16/8] w-full object-cover transition-transform duration-700 hover:scale-105" />
                </div>
              </Reveal>
              <Reveal delay={0.08}>
                <p className="mt-8 text-sm leading-loose text-gray-300 sm:text-base">{s.detail}</p>
              </Reveal>
              <ul className="mt-8 grid gap-3 sm:grid-cols-2">
                {s.scope.map((sc, j) => (
                  <Reveal key={sc} delay={0.05 * j}>
                    <li data-testid={`service-scope-${s.slug}-${j}`} className="flex items-center gap-3 border border-line bg-panel px-4 py-3 text-sm text-gray-300">
                      <span className="h-1.5 w-1.5 shrink-0 rotate-45 bg-accent" />
                      {sc}
                    </li>
                  </Reveal>
                ))}
              </ul>
            </div>
          </div>
        </section>
      ))}
      <CtaSection title="どの事業のことでも、" highlight="お気軽にご相談ください。" text="工事のご依頼・お見積りは無料です。現地調査から承ります。" button="見積・工事の相談" to="/contact?type=estimate" />
    </div>
  );
}
